import { Component, ElementRef, OnInit, ViewChild, input, model } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, map, of, startWith } from 'rxjs';
import { AssessmentService } from 'src/app/services/assessment.service';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-edit-contact',
    templateUrl: './edit-contact.component.html',
    styleUrl: './edit-contact.component.scss',
    standalone: false
})
export class EditContactComponent implements OnInit {
  edit_contact = model<boolean>();
  refreshUser = input<Subject<void>>();
  user = input<any>();
  selectedForestFlag = false;
  selectedForestFlag_duty = false;

  agencies: any;
  regions: any;
  forest_names: any;
  forest_names_duty: any;
  filtered_forest_names: Observable<string[]>;
  filtered_forest_names_duty: Observable<string[]>;
  @ViewChild('forest') input?: ElementRef<HTMLInputElement>;

  contactForm = this.formBuilder.group({
    first_name: [""],
    last_name: [""],
    email: [""],
    phone: [""],
    agency_id: [-1, Validators.min(0)],
    location_id: [-1],
    region: [""],
    forest_name: [""],
    duty_location_id: [-1],
    duty_region: [""],
    duty_forest_name: [""],
  });

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly assessmentService: AssessmentService,
    private readonly userService: UserService,
    private readonly dialogService: DialogService
  ) {
    this.agencies = this.userService.getAgencyList();
    this.regions = this.assessmentService.getRegionList();
    this.forest_names = this.assessmentService.getForestNameList();

    this.filtered_forest_names = this.contactForm.controls["forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )

    this.filtered_forest_names_duty = this.contactForm.controls["duty_forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )
  }

  ngOnInit(): void {
    this.contactForm.patchValue({
      first_name: this.user().first_name,
      last_name: this.user().last_name,
      email: this.user().email,
      phone: this.user().phone_num,
      agency_id: this.user().agency_id,
      location_id: this.user().location_id,
      region: this.user().region,
      forest_name: this.user().forest_name,
      duty_location_id: this.user().duty_location_id,
      duty_region: this.user().duty_region,
      duty_forest_name: this.user().duty_forest_name,
    })
    this.updateValidators(null, null)
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forest_names.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  private _filter_duty(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forest_names_duty.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  filter(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names = of(this._filter(filterValue));
  }

  filter_duty(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names_duty = of(this._filter_duty(filterValue));
  }

  regionChanged(): void {
    this.contactForm.controls.forest_name.setValue('')
    this.forest_names = this.assessmentService.getForestNameList(this.contactForm.value.region ?? undefined);
    this.filtered_forest_names = this.contactForm.controls["forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )
  }

  regionChanged_duty(): void {
    this.contactForm.patchValue({ duty_forest_name: undefined })
    this.forest_names_duty = this.assessmentService.getForestNameList(this.contactForm.value.duty_region ?? undefined);
    this.filtered_forest_names_duty = this.contactForm.controls["duty_forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter_duty((value as string) || ""))
    )
  }

  save() {
    let role_list: any[] = [];
    let isActive = this.userService.checkAgencyRegionForest(this.contactForm.value.agency_id, this.contactForm.value.location_id, this.contactForm.value.region, this.contactForm.value.forest_name)
    if (isActive && !this.user().baer_roles?.find((role:any)=> role.baer_role_id == 2)) role_list = [{ baer_role_id: 2 }]
    this.dialogService.openSpinner()

    this.userService.editUserDetails({
      user_id: this.user().user_id,
      first_name: this.contactForm.value.first_name,
      last_name: this.contactForm.value.last_name,
      email: this.contactForm.value.email,
      phone_num: this.contactForm.value.phone,
      agency_id: this.contactForm.value.agency_id,
      location_id: this.contactForm.value.location_id,
      region: this.contactForm.getRawValue().region,
      forest_name: this.contactForm.value.forest_name,
      duty_location_id: this.contactForm.value.duty_location_id,
      duty_region: this.contactForm.getRawValue().duty_region || undefined,
      duty_forest_name: this.contactForm.value.duty_forest_name,
      user_baer_roles: role_list
    }).subscribe(() => {
      this.edit_contact.update((x) => {
        return false;
      });
      this.userService.refreshUserProfile();
      this.refreshUser()!.next();
      this.dialogService.closeSpinner();
    })
  }

  cancel() {
    this.edit_contact.update((x) => {
      return false;
    });
  }

  clearForest() {
    if (!this.selectedForestFlag) {
      this.contactForm.patchValue({
        forest_name: ""
      })
    }
    this.selectedForestFlag = false
  }

  clearForest_duty() {
    if (!this.selectedForestFlag_duty) {
      this.contactForm.patchValue({
        duty_forest_name: ""
      })
    }
    this.selectedForestFlag_duty = false
  }

  forestNameSelected(event: any): void {
    let orgCode = this.assessmentService.getOrgCodeFromForest(event.option.value)
    this.contactForm.patchValue({
      region: orgCode?.substring(0, 2),
    })
    this.selectedForestFlag = true
  }

  forestNameSelected_duty(event: any): void {
    this.selectedForestFlag_duty = true
  }

  updateValidators(value: any, type: any) {
    let location_id = this.contactForm.controls.location_id.value;
    let duty_location_id = this.contactForm.controls.duty_location_id.value;
    let agency_id = this.contactForm.value.agency_id;
    if (type == 'location_id') {
      location_id = value;
    }
    if (type == 'duty_location_id') {
      duty_location_id = value;
    }
    if (type == 'agency_id') {
      agency_id = value;
    }
    this.updateValidatorsCheck(location_id, duty_location_id, agency_id);
  }

  updateValidatorsCheck(location_id: any, duty_location_id: any, agency_id: any): void {
    if (location_id != 0) {
      this.contactForm.controls.forest_name.clearValidators();
      this.contactForm.controls.forest_name.setValue('');

      if (location_id != 1) {
        this.contactForm.controls.region.clearValidators();
        this.contactForm.controls.region.setValue("WO");
      }
    }
    if (duty_location_id != 0) {
      this.contactForm.controls.duty_forest_name.clearValidators();
      this.contactForm.controls.duty_forest_name.setValue('');

      if (duty_location_id != 1) {
        this.contactForm.controls.duty_region.clearValidators();
        this.contactForm.controls.duty_region.setValue("WO");
      }
    }
    if (agency_id != 0 && location_id == 2) {
      this.contactForm.controls.location_id.setValue(null);
    }

    let type: string | null = null;
  }
}
